import type { PostBulkSmsEstimate } from "@/server-types";

// The English line ("\nStop: " and the 23 characters Infobip shortens any link
// to), counted until the estimate reports the line in the sender's language.
const ENGLISH_OPT_OUT_LENGTH = 30;

export function promotionalOptOutLength(
  estimate:
    | Pick<PostBulkSmsEstimate["response"], "promotionalOptOutLength">
    | undefined,
): number {
  return estimate?.promotionalOptOutLength ?? ENGLISH_OPT_OUT_LENGTH;
}

export function withOptOutPlaceholder({
  content,
  purpose,
  optOutLength,
}: {
  content: string;
  purpose: string;
  optOutLength: number;
}): string {
  if (purpose !== "promotional") return content;
  return `${content}${"X".repeat(optOutLength)}`;
}
